import { ErrorHandler, Injectable, inject } from '@angular/core';
import {LogService} from "./log.service"

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandler implements ErrorHandler {
  private logService = inject(LogService);


  handleError(error: Error) {
   this.logService.messageError('Attenzione', error.message, error);
  }

}
